// Comment: This component is responsible for rendering the banner section of the survey page. It takes in several props to determine the content and styling of the banner, including the banner text, display message, error state, and survey type (single or wl survey). Depending on the error state and survey type, it conditionally renders different classes and content within the banner.
const Banner = ({bannerText,displayMessage, isError, singleSurvey, wlSurvey}) => {
        
    if (!isError) {
        return (
            <div className='container-fluid p-0'>
                <div className={wlSurvey === true ? 'main-banner-wl-survey' : singleSurvey === false ? 'main-banner' : 'main-banner-single-survey'}>
                    <div className='col-md-12 text-center'>
                        <h2 className={wlSurvey === true ? 'main-heading-single-survey' : singleSurvey === false ? 'main-heading' : 'main-heading-single-survey'}>{displayMessage}</h2>
                        <p className='banner-text text-white'>{bannerText}</p>
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div className='container-fluid p-0'>
                <div className={wlSurvey === true ? 'main-banner-wl-survey' : singleSurvey === false ? 'main-banner' : 'main-banner-single-survey'}>
                    <div className='col-md-12 text-center'>
                        <h2 className={wlSurvey === true ? 'main-heading-single-survey' : singleSurvey === false ? 'main-heading' : 'main-heading-single-survey'}>{displayMessage}</h2>
                    </div>
                </div>
            </div>
        );
    }
}

export default Banner;